import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { TableRow, TableCell, Stack, Checkbox } from '@mui/material';
import { ChevronDown } from 'mdi-material-ui';
import Row from './Row';
const GroupedRow = ({ columns, data, label, render, selectable, getRowId, onCheckboxChange, selectedIds, onHeaderSelect, }) => {
    const [toggle, setToggle] = useState(false);
    const allSelected = Boolean(data.every((i) => selectedIds.includes(i._id)));
    return (_jsxs(React.Fragment, { children: [_jsxs(TableRow, Object.assign({ sx: { height: '54px' } }, { children: [selectable && (_jsx(TableCell, { children: _jsx(Checkbox, { checked: allSelected, indeterminate: allSelected
                                ? false
                                : data.some((i) => selectedIds.includes(i._id)), onChange: (e, checked) => onHeaderSelect(label, checked) }) })), _jsx(TableCell, Object.assign({ colSpan: columns.length }, { children: _jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", gap: 1 }, { children: [render({ label, data }), _jsx(ChevronDown, { sx: {
                                        backgroundColor: '#F5F4FC',
                                        color: '#4E3BC9',
                                        borderRadius: '50%',
                                        padding: '2px',
                                        transition: '0.25s all ease',
                                        transform: toggle ? 'rotate(180deg)' : 'rotate(360deg)',
                                        marginX: '4px',
                                    }, onClick: () => setToggle((prevState) => {
                                        return !prevState;
                                    }) })] })) }))] })), toggle &&
                data.map((row, idx) => (_jsx(Row, { columns: columns, getRowId: getRowId, onCheckboxChange: onCheckboxChange, row: row, selectable: selectable, selectedIds: selectedIds }, `${idx}`)))] }));
};
export default GroupedRow;
